/**
 * Suppresses specific React Flow development warnings
 * React Flow uses console.warn for development warnings, some of which are false positives
 */
export function suppressReactFlowWarnings() {
  const originalWarn = console.warn;
  console.warn = (...args: any[]) => {
    // Suppress specific React Flow warnings that are false positives
    if (typeof args[0] === 'string') {
      // Suppress the nodeTypes/edgeTypes warning - our types are correctly defined outside components
      if (args[0].includes('[React Flow]') && args[0].includes('nodeTypes or edgeTypes')) {
        return;
      }
      // In production, suppress all React Flow warnings
      if (import.meta.env.PROD && (args[0].includes('[React Flow]') || args[0].includes('reactflow'))) {
        return;
      }
    }
    originalWarn.apply(console, args);
  };
}
